var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "width": "900",
      "mask-closable": false,
      "title": _vm.modal.title,
      "footer-hide": ""
    },
    on: {
      "on-cancel": _vm.clean
    },
    model: {
      value: _vm.modal.visible,
      callback: function ($$v) {
        _vm.$set(_vm.modal, "visible", $$v);
      },
      expression: "modal.visible"
    }
  }, [_vm.modal.visible ? _c('div', {
    staticClass: "agreement_index"
  }, [_vm.config.agreementType === 'user' ? _c('AgreementUser') : _c('AgreementPolicy')], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };